import { Col, Row, Form, Input, Button, Card } from "antd";
import { ImWhatsapp } from "react-icons/im";
import { ImageUrl } from "../../../config/helper";
import { Container } from "postcss";
import { FaArrowRightLong } from "react-icons/fa6";
import Slider from "react-slick";
import { IoLocationSharp } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import { IoMdClock } from "react-icons/io";

const { Meta } = Card;
const onFinish = (values) => {
  console.log("Success:", values);
};
const onFinishFailed = (errorInfo) => {
  console.log("Failed:", errorInfo);
};

const HomeComponent14 = () => {
  const settings = {
    dots: false,
    // arrows:false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <>
      <section className="py-5 home-modals-box">
        <Row justify={"center"}>
          <Col lg={18}>
            <Row className="">
              <Col xxl={8} xl={8} lg={8} md={8} sm={23} xs={23}>
                <div className="adress-box">
                  <div className="adres-icon-box">
                    <IoLocationSharp />
                  </div>
                  <h4 className="font-goldman text-white">Address</h4>
                  <p>
                    Luxury Car Chauffeur Service 5000 Riverdale road, suite 312
                    Riverdale, New Jersey, N.J. 07457
                  </p>
                </div>
              </Col>
              <Col xxl={8} xl={8} lg={8} md={8} sm={23} xs={23}>
                <div className="adress-box">
                  <div className="adres-icon-box">
                  <MdEmail />
                  </div>
                  <h4 className="font-goldman text-white">Email</h4>
                  <p>
                  Email: info@luxuryccs.com
                  </p>
                </div>
              </Col>
              <Col xxl={8} xl={8} lg={8} md={8} sm={23} xs={23}>
                <div className="adress-box">
                  <div className="adres-icon-box">
                  <IoMdClock />
                  </div>
                  <h4 className="font-goldman text-white">Working Hours</h4>
                  <p>
                  We’re open 24/7
                  </p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </section>
    </>
  );
};

export default HomeComponent14;
